// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rec-card[data-v-11b08258]{position:relative;display:flex;flex-direction:column;padding:var(--v18b1c99a);height:var(--v4c9d9c3b);max-height:100%;width:var(--v70d49d9e);max-width:100%;border-radius:var(--v7e55bee4);overflow:hidden}.rec-card--elevated[data-v-11b08258]{box-shadow:0.1875rem 0.3125rem 0.9375rem rgba(0,0,0,.15)}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
